import { type paths } from "@frend-digital/centra-types/oas";
import createClient, { type ClientOptions } from "openapi-fetch";

export type CreateClientOptions = Omit<ClientOptions, "baseUrl" | "headers"> & {
  headers?: HeadersInit;
};

export const createCentraClient = (
  url: string,
  accessToken?: string,
  options: Partial<CreateClientOptions> = {}
) => {
  const headers = new Headers(options.headers);

  if (accessToken) {
    headers.append("Authorization", `Bearer ${accessToken}`);
  }

  return createClient<paths>({
    baseUrl: url,
    ...options,
    headers,
  });
};

export type CentraClient = ReturnType<typeof createCentraClient>;
